// API
import { api } from './api';

export async function fetchUser() {
    const resp = await fetch(api.auth, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
        },
    });

    return resp.status === 200 ? resp.json() : Promise.reject();
}

export async function fetchUpdateUser(page: string) {
    const resp = await fetch(`${api.authUpdate}?post_login_redirect_url=${page}`, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
        },
    });

    return resp.status === 200 ? Promise.resolve() : Promise.reject();
}
